import { render, staticRenderFns } from "./PublishTweetSolidBtn.vue?vue&type=template&id=053cf0a1&scoped=true&"
import script from "./PublishTweetSolidBtn.vue?vue&type=script&lang=js&"
export * from "./PublishTweetSolidBtn.vue?vue&type=script&lang=js&"
import style0 from "./PublishTweetSolidBtn.vue?vue&type=style&index=0&id=053cf0a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053cf0a1",
  null
  
)

export default component.exports